export enum SourceType {
  CircleCi = "circleci",
  Slack = "slack",
  Jira = "jira",
  Github = "github",
  Gitlab = "gitlab",
  GCalendar = "gcalendar",
  Snyk = "snyk",
}

export enum GcalConfigType {
  service = "service",
  oauth = "configuration-oauth",
}

export type Source = {
  id: string;
  name: string;
  authToken: string;
  status: string;
  uuid: string;
  webhook_url: string;
  created_at: string;
  updated_at: string;
  secrets: Secret[];
  secret: string;
  username: string;
  host: string;
  scope: object;
  kind: string;
  installationAccount: string;
};

export type SourceCheck = {
  id: string;
  latestHits: Record<string, string>;
  erroredAt: string[];
  updatedAt: string;
};

export type SourceConfig = {
  id?: string;
  orgId: string;
  name: string;
  kind: string;
  clientId?: string;
  secret?: string;
  url: string;
};

export type Secret = {
  id: string;
  secret: string;
};

export type FacetOption = { label: string; value: string; count: number };
